import { Loader } from '@googlemaps/js-api-loader'

const googleMapsApi = new Loader({
  apiKey: GOOGLE_MAPS_API_KEY,
  version: '3.exp',
  libraries: ['places'],
})

googleMapsApi.load().then((google) => {
  Promise.all([import('./contact-block.scss'), import('../kentico-form/kentico-form')]).then(() => {
    $('.widget.contact-block').each(function (i, el) {
      $(el).data('widget', new ContactBlock(el, google))
      $(el).data('widget').init()
    })
  })
})

function ContactBlock(el, google) {
  const self = this
  self.el = $(el)
  self.formContainer = self.el.find('.form-container')

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ContactBlock init', self)
    }

    self.el.css('opacity', 1)

    initMap()

    if (self.formContainer.attr('data-park-form-recipient')) {
      self.formContainer.find('input[type=hidden]').each(function () {
        if ($(this).attr('name').indexOf('Recipient.Value') > -1) {
          $(this).val(self.formContainer.attr('data-park-form-recipient'))
          return false
        }
      })
    }

    if (self.formContainer.attr('data-park-form-title')) {
      self.formContainer.find('input[type=hidden]').each(function () {
        if ($(this).attr('name').indexOf('ParkTitle.Value') > -1) {
          $(this).val(self.formContainer.attr('data-park-form-title'))
          return false
        }
      })
    }

    // Get park code
    self.parkCodes = []
    const parkCode = self.el.attr('data-park-code')
    if (parkCode) {
      console.log('Found park code:', parkCode)
      self.parkCodes.push(parkCode)
    } else {
      console.warn('No park code found in contact block element')
    }

    // Remove duplicates
    self.parkCodes = [...new Set(self.parkCodes)]

    // Fetch and display ratings
    fetchReviewsForParks(self.parkCodes).then(displayRatings)
  }

  async function fetchReviewsForParks(parkCodes) {
    // Check if we have parkCodes, its an array and has at least one code
    if (!Array.isArray(parkCodes) || parkCodes.length === 0) {
      console.warn('No park codes provided for fetching reviews.')
      return []
    }

    const endpoint = self.el.attr('data-api-endpoint')
    const method = self.el.attr('data-api-method')
    const gdayCaller = self.el.attr('data-api-gday-caller')

    if (!gdayCaller) {
      console.error('No Gday-Caller header provided for fetchReviewsForParks')
      return
    }

    if (!endpoint && !method) {
      console.error('No API endpoint or method defined for fetchReviewsForParks')
    }

    // Create an array of fetch requests for each park code
    const requests = parkCodes.map((parkCode) => {
      // Replace {parkCode} in the endpoint template with the actual park code
      const url = endpoint.replace('{parkCode}', parkCode)

      return fetch(url, {
        method: method,
        headers: {
          'Gday-Caller': gdayCaller,
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`)
          return response.json().then((data) => ({ parkCode, data }))
        })
        .catch((error) => ({ parkCode, error: error.message }))
    })

    const results = await Promise.allSettled(requests)

    // Flatten to final review data array (fulfilled values)
    const reviews = results.map((result) => {
      if (result.status === 'fulfilled') {
        return result.value // { code, data } or { code, error }
      } else {
        return { code: 'unknown', error: result.reason.message || 'Unknown error' }
      }
    })

    return reviews
  }

  function displayRatings(reviews) {
    reviews.forEach(({ parkCode, data, error }) => {
      if (error) {
        console.warn(`Failed to fetch reviews for ${parkCode}: ${error}`)
        return
      }

      // Convert overallRating (out of 10) to rating out of 5
      const rawRating = data.overallRating
      let displayRating = 'N/A'
      if (typeof rawRating === 'number') {
        const score = rawRating / 2
        const rating = Number.isInteger(score) ? score : score.toFixed(1)
        displayRating = `${rating}`
      }

      const ratingValueEl = self.el.find('.js-rating-value')[0]
      console.log('ratingValueEl', ratingValueEl)

      if (!ratingValueEl) {
        console.warn(`No .js-rating-value element found. Cannot display rating for ${parkCode}`)
        return
      }

      ratingValueEl.textContent = displayRating
      // get parent .js-rating element and remove opacity-0 class
      const ratingContainer = ratingValueEl.closest('.js-rating')
      if (ratingContainer) {
        ratingContainer.classList.remove('opacity-0')
      } else {
        console.warn(`No parent .js-rating element found for ${el}`)
      }
    })
  }

  function initMap() {
    const mapCanvasEl = self.el.find('.map-canvas').get(0)
    const lat = parseFloat(self.el.find('.map').attr('data-lat'))
    const lng = parseFloat(self.el.find('.map').attr('data-lng'))

    if (!mapCanvasEl || isNaN(lat) || isNaN(lng)) {
      return
    }

    self.map = new google.maps.Map(mapCanvasEl, {
      center: { lat, lng },
      zoom: 13,
      maxZoom: 18,
      disableDefaultUI: true,
    })

    // NOTE: New Figma does not show marker icon
    // const markerIconSrc = self.el.find('.map').attr('data-pin')
    // self.marker = new google.maps.Marker({
    //   position: { lat, lng },
    //   map: self.map,
    //   icon: {
    //     url: markerIconSrc,
    //     size: new google.maps.Size(190, 166),
    //     origin: new google.maps.Point(0, 0),
    //     anchor: new google.maps.Point(47, 71),
    //     scaledSize: new google.maps.Size(95, 83),
    //   },
    // })
  }
}
